import { LOADING_PROGRESS } from '@ezugi/constants';
import { calcDownloadedSize } from '@ezugi/utils';

class PostMessage {

  constructor() {
    this.listeners = [];
    this.init = false;
  }

  removeListener(id) {
    this.listeners = this.listeners.filter((listener) => listener.id !== id);
  }

  addListener(callback, id) {
    if (!this.init) {
      window.addEventListener('message', this.receiveMessage, false);
      this.init = true;
    }

    this.listeners.push({ callback, id });
  }

  receiveMessage(event) {
    let data = {};

    try {
      data = JSON.parse(event.data);
    } catch (_e) {
      return false;
    }

    this.listeners
      .filter(
        (listener) => listener.id === data.post_message_id && listener.callback,
      )
      .forEach((listener) => {
        listener.callback(data);
      });

    return true;
  }

  // eslint-disable-next-line class-methods-use-this
  sendMessage(messageType, params = {}, stringify = true) {
    try {
      const parent = window !== window.parent ? window.parent : window.opener;

      if (!parent) return;

      const message = stringify
        ? JSON.stringify({
          ...params,
          msg_type: messageType,
        })
        : { ...params, msg_type: messageType };

      parent.postMessage(message, '*');
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(`Post message failed for ${messageType}`, e);
    }
  }

}

const PostMessageAPI = new PostMessage();

export const sendHomeMessage = () => {
  PostMessageAPI.sendMessage('navigation', { msg: 'close_game' });
};

export const sendCashierMessage = (uid) => {
  PostMessageAPI.sendMessage('navigation', {
    msg: 'cashier',
    player_id: uid,
  });
};

export const sendReadyMessage = () => {
  PostMessageAPI.sendMessage('page_flow', { msg: 'ready' });
};

export const sendLoadingMessage = () => {
  PostMessageAPI.sendMessage('page_flow', {
    msg: 'loading',
    version: window.__TAG_VERSION,
  });
};

export const sendGameLoadedMessage = (gameName) => {
  PostMessageAPI.sendMessage('page_flow', {
    msg: 'game_loaded',
    value: gameName,
  });
};

export const sendAssetLoadedMessage = (assetName) => {
  PostMessageAPI.sendMessage('page_flow', {
    msg: 'asset_loaded',
    value: assetName,
  });
};

export const sendResourceReportMessage = () => {
  PostMessageAPI.sendMessage(
    'page_flow',
    {
      type: LOADING_PROGRESS,
      data: calcDownloadedSize(false),
    },
    false,
  );
};

export const sendOpenTableMessage = (
  gameName,
  gameId,
  tableId,
  limitId,
  seatIndex,
  uiGameName,
  languageCode,
) => {
  PostMessageAPI.sendMessage('open_table', {
    uiGameName,
    msg: 'open_table',
    game_name: gameName,
    game_id: gameId,
    table_id: tableId,
    limit_id: limitId,
    seat_index: seatIndex,
    language_code: languageCode,
  });
};

// Sending current game/lobby height for operators to match iframe to needed lobby/game size
export const sendHeightMessage = (height) => {
  PostMessageAPI.sendMessage('page_flow', {
    msg: 'height',
    value: height,
  });
};

export const sendUkgsMessage = (option) => {
  PostMessageAPI.sendMessage('rc_message', { msg: option });
};

// Send error message via post message (only for loading and fatal errors)
export const sendErrorMessage = (message, code) => {
  PostMessageAPI.sendMessage('error', {
    msg: 'error',
    value: message,
    code,
  });
};

export const sendEnterFullscreenMessage = () => {
  PostMessageAPI.sendMessage('fullscreen_change', {
    msg: 'enter_fullscreen',
  });
};

export const sendExitFullscreenMessage = () => {
  PostMessageAPI.sendMessage('fullscreen_change', {
    msg: 'exit_fullscreen',
  });
};
